export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER'
export const WARRANTY_SUBMIT = 'WARRANTY_SUBMIT'
export const WARRANTY_RESPONSE = 'WARRANTY_RESPONSE'
export const WARRANTY_SELECT = 'WARRANTY_SELECT'
export const WARRANTY_LOADED = 'WARRANTY_LOADED'
export const FETCH_BLOGPOSTS = 'FETCH_BLOGPOSTS'
export const FETCH_TRANSACTIONS = 'FETCH_TRANSACTIONS'
export const CONTRACT_URL_RESPONSE = 'CONTRACT_URL_RESPONSE'
export const SET_D2C_IS_INSTALLED = 'SET_D2C_IS_INSTALLED'
export const VALIDATE_WARRANTY_ISSUED_START = 'VALIDATE_WARRANTY_ISSUED_START'
export const VALIDATE_WARRANTY_ISSUED_RESPONSE =
  'VALIDATE_WARRANTY_ISSUED_RESPONSE'
export const VALIDATE_WARRANTY_ISSUED_ERROR = 'VALIDATE_WARRANTY_ISSUED_ERROR'
export const FETCH_SI_POLICIES = 'FETCH_SI_POLICIES'
